import React from 'react';
import Close from '@mui/icons-material/Close';
import Info from '@mui/icons-material/Info';
import {
  Button,
  Breakpoint,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';

const useStyles = makeStyles(() => {
  return {
    dialogWrapper: {
      minWidth: 468,
      minHeight: 200,
      flexDirection: 'column',
      justifyContent: 'space-between',
      display: 'flex',
      padding: 16,
      paddingTop: 0,
      '& > *': {
        padding: 0,
        paddingTop: 10
      }
    }
  };
});

export interface BaseModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  maxWidth?: Breakpoint;
}

// todo: make this an FC component, no state is needed
export class BaseModal<P extends BaseModalProps> extends React.Component<P> {
  title: string;

  constructor(props: P) {
    super(props);
    this.title = props.title;
    this.state = {};
  }

  onClose() {
    this?.props?.onClose();
  }

  ModalComponent: React.FC = props => {
    const { children } = props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.onClose}
        style={{ minWidth: '200px' }}
        maxWidth={this.props.maxWidth}
      >
        {children || null}
      </Dialog>
    );
  };

  Content: React.FC<any> = props => {
    const { children } = props;
    return (
      <DialogContent style={{ padding: 0, maxWidth: 'sm' }}>
        {children}
      </DialogContent>
    );
  };

  Actions: React.FC = () => {
    return (
      <DialogActions>
        <Button variant="outlined" onClick={this.onClose}>
          OK
        </Button>
      </DialogActions>
    );
  };

  Header: React.FC = () => {
    const Icon = this.Icon;
    const theme = useTheme();
    return (
      <Grid
        container
        display="flex"
        alignItems={'center'}
        style={{ padding: '16px' }}
      >
        <Icon />
        <DialogTitle>
          <Typography
            variant="h5"
            style={{
              color: theme.palette.text.primary,
              ...((theme.typography.body1 as any) || {})
            }}
          >
            {this.props.title}
          </Typography>
        </DialogTitle>
      </Grid>
    );
  };

  iconStyle: React.CSSProperties = {
    fontSize: '40px'
  };
  Icon: React.FC<any> = () => {
    const theme = useTheme();
    return (
      <Info
        style={{
          ...this.iconStyle,
          color: theme.palette.primary[600]
        }}
      />
    );
  };

  CloseIcon: React.FC = () => {
    return (
      <IconButton
        style={{
          position: 'absolute',
          zIndex: 100,
          right: '8px',
          top: '8px'
        }}
        onClick={() => {
          this.onClose()
        }}
      >
        <Close />
      </IconButton>
    );
  };

  Wrapper: React.FC = ({ children }) => {
    const classes = useStyles();
    return <Container className={classes.dialogWrapper}>{children}</Container>;
  };

  render(): React.ReactNode {
    const { ModalComponent, Wrapper, CloseIcon, Header, Content, Actions } =
      this;

    return (
      <ModalComponent>
        <CloseIcon />
        <Header />
        <Wrapper>
          <Content>{this.props.children}</Content>
          <Actions />
        </Wrapper>
      </ModalComponent>
    );
  }
}
